import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';
import { applyDomainFilterToQuery } from './useDomainQuery';

export const useOrderNotifications = () => {
  const [paidCount, setPaidCount] = useState<number>(0);
  const [pendingCount, setPendingCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const { user } = useAuth();

  const fetchOrderCounts = async () => {
    if (!user) {
      setPaidCount(0);
      setPendingCount(0);
      setLoading(false);
      return;
    }

    try {
      let query = supabase
        .from('shop_orders')
        .select('*');
      
      // Appliquer le filtrage par domaine
      query = applyDomainFilterToQuery(query);
      
      const { data: orders, error } = await query;

      if (error) {
        console.error('Erreur lors de la récupération des commandes:', error);
        return;
      }

      // Filtrer les commandes par statut côté client
      const paidOrders = orders?.filter(order => order.status === 'paid') || [];
      const pendingOrders = orders?.filter(order => order.status === 'pending_payment') || [];
      
      setPaidCount(paidOrders.length);
      setPendingCount(pendingOrders.length);

      // Les compteurs sont déjà définis plus haut
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderCounts();

    // Abonnement aux changements dans la table des commandes
    const subscription = supabase
      .channel('shop_orders_changes')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'shop_orders' 
        }, 
        () => {
          fetchOrderCounts();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [user]);

  return { paidCount, pendingCount, loading, refetch: fetchOrderCounts };
};
